






















import { Subscription, EventJson } from '@ssp/inscreva-sse-models';
import { ChartData, ChartOptions, ChartTooltipItem } from 'chart.js';
import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

import { sessionStore } from '@/store/session';

import SubscriptionChartBar from './SubscriptionChartBar.vue';
import toast from './toast';
import { ToastType } from './toast/tost-type.enum';

export type Month = { month: string; days: number };
@Component({
  components: {
    SubscriptionChartBar,
  },
})
export default class SubscriptionChartComponent extends Vue {
  @Prop({ required: true })
  private subscriptions!: Array<Subscription>;

  private isLoading: boolean = false;

  private month: Month = null;

  private datacollection: ChartData = {};

  private dataoptions: ChartOptions = {};

  mounted() {
    this.fillData();
  }

  getMonthsOverall(): Array<Month> {
    return [
      { month: 'Janeiro', days: 31 },
      { month: 'Fevereiro', days: 29 },
      { month: 'Março', days: 31 },
      { month: 'Abril', days: 30 },
      { month: 'Maio', days: 31 },
      { month: 'Junho', days: 30 },
      { month: 'Julho', days: 31 },
      { month: 'Agosto', days: 31 },
      { month: 'Setembro', days: 30 },
      { month: 'Outubro', days: 31 },
      { month: 'Novembro', days: 30 },
      { month: 'Dezembro', days: 31 },
    ];
  }

  getMonths(): Array<Month> {
    const regexSimpleDate = /^\d{2}\/\d{2}\/\d{4}$/;
    const regexISODate = /^\d{4}-\d{2}-\d{2}T.*?$/;
    const date = EventJson.fromJson(sessionStore.session.event).info.date.end;
    const formattedDate = regexSimpleDate.test(date)
      ? moment(date, 'DD/MM/YYYY').toISOString()
      : regexISODate.test(date) && date;
    if (!formattedDate) {
      toast('Data do evento com erro', ToastType.ERROR);
      return [];
    }
    const eventMonth = new Date(formattedDate).getMonth();
    return this.getMonthsOverall().filter((month, monthIndex) => monthIndex <= eventMonth);
  }

  getDays(m: Month): Array<number> {
    return new Array(m.days).fill(null).map((v, index) => index + 1);
  }

  getMonthData(m: Month, activeStatus: boolean = true) {
    const monthIndex: number = this.getMonths().findIndex(({ month }) => month === m.month);
    return this.getDays(m).map(
      (day: number) =>
        this.subscriptions.filter(
          ({ createdAt, active }) =>
            (activeStatus === true ? active === true : active === false) &&
            new Date(createdAt).getMonth() === monthIndex &&
            new Date(createdAt).getDate() === day,
        ).length,
    );
  }

  getMonthsData(subscriptions: Array<Subscription>, activeStatus: boolean = true): Array<{ quantity: number }> {
    const months = this.getMonths();
    return months.map((month, index) => ({
      quantity: subscriptions.filter(
        ({ createdAt, active }) =>
          (activeStatus === true ? active === true : active === false) && new Date(createdAt).getMonth() === index,
      ).length,
    }));
  }

  fillData() {
    this.datacollection = {
      labels: this.month ? this.getDays(this.month) : this.getMonths().map(({ month }) => month),
      datasets: [
        {
          label: `${(this.month && this.month.month) || 'Ativas'}: ${
            this.subscriptions.filter(({ active }) => active !== false).length
          }`,
          backgroundColor: '#2c3e5066',
          borderColor: '#2c3e50',
          hoverBackgroundColor: '#2c3e50',
          borderWidth: 2,
          data: this.month
            ? this.getMonthData(this.month)
            : this.getMonthsData(this.subscriptions).map(({ quantity }) => quantity),
        },
        {
          label: `${(this.month && this.month.month) || 'Inativas'}: ${
            this.subscriptions.filter(({ active }) => active === false).length
          } | Total: ${this.subscriptions.length}`,
          backgroundColor: 'indianred',
          borderColor: 'darkred',
          hoverBackgroundColor: 'darkred',
          borderWidth: 2,
          data: this.month
            ? this.getMonthData(this.month, false)
            : this.getMonthsData(this.subscriptions, false).map(({ quantity }) => quantity),
        },
      ],
    };
    this.dataoptions = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              stepSize: 1,
            },
          },
        ],
      },
      tooltips: {
        callbacks: {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          label: (tooltipItem: ChartTooltipItem, data: ChartData) => {
            if (!this.month) {
              return `${tooltipItem.value} Inscrições`;
            }
            const monthDate = this.getMonths().findIndex(({ month }) => month === this.month.month) + 1;
            const formattedDate = `${tooltipItem.label}/${monthDate}/${new Date().getFullYear()}`;
            return `${formattedDate} - ${tooltipItem.value} Inscrições`;
          },
        },
      },
      onClick: this.clickOnChart,
    };
  }

  onUpdate() {
    this.fillData();
  }

  clickOnChart(chart: any, event: any) {
    this.month = this.getMonths().find(({ month }) => month === event[0]?._model?.label);
    this.fillData();
  }

  clearMonth() {
    this.month = null;
    this.fillData();
  }
}
